import * as React from 'react'

export const LemaNewCapabilities = ({ children }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className='flex flex-col gap-0.5 pt-3 [&_p]:m-0 [&_p]:text-main-foreground-secondary [&_p]:!text-label-small [&_strong]:text-main-foreground-primary'>
    {children}
  </div>
)
